exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cat-code-editor{display:inline-block}.cat-code-editor .label{display:inline-block;height:26px;padding-top:4px}.cat-code-editor .label.prefix{margin-right:2px}.cat-code-editor .input{width:140px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-bb97aeba","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/comn/CatCodeEditor.vue
// module id = 4653
// module chunks = 0